import React, { useState, useRef, useEffect, useCallback } from 'react';
import css from '../../utils/css';

const classes = css`
  .grab {
    cursor: grab;
  }
  .grabbing {
    cursor: grabbing;
  }
`;

const DragScroll = React.forwardRef(
  (
    { children, height, width, overflow = 'auto', className, onScroll },
    ref
  ) => {
    const [isDragging, setIsDragging] = useState(false);

    const dragStartCoords = useRef({ x: 0, y: 0 });

    const internalRef = useRef(null);
    const containerRef = ref || internalRef;

    const handleMouseDown = useCallback(
      (e) => {
        if (containerRef.current) {
          setIsDragging(true);
          dragStartCoords.current = {
            x: e.clientX,
            y: e.clientY,
          };
          e.preventDefault();
        }
      },
      [containerRef]
    );

    const handleMouseUp = useCallback(() => {
      setIsDragging(false);
    }, []);

    const handleMouseMove = useCallback(
      (e) => {
        if (!isDragging || !containerRef.current) return;

        const dx = e.clientX - dragStartCoords.current.x;
        const dy = e.clientY - dragStartCoords.current.y;

        containerRef.current.scrollLeft -= dx;
        containerRef.current.scrollTop -= dy;

        dragStartCoords.current = {
          x: e.clientX,
          y: e.clientY,
        };
      },
      [isDragging, containerRef]
    );

    useEffect(() => {
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('mousemove', handleMouseMove);

      return () => {
        window.removeEventListener('mouseup', handleMouseUp);
        window.removeEventListener('mousemove', handleMouseMove);
      };
    }, [handleMouseUp, handleMouseMove]);

    const dynamicClasses = `${className || ''} ${
      isDragging ? classes.grabbing : classes.grab
    }`;

    return (
      <div
        ref={containerRef}
        className={dynamicClasses}
        style={{ height, width, overflow }}
        onMouseDown={handleMouseDown}
        onScroll={onScroll}
      >
        {children}
      </div>
    );
  }
);

export default DragScroll;
